export default __webpack_public_path__ + "static/media/user_icon.78b8326a.png";